module.exports = __webpack_public_path__ + "img/rope_1ThimbleLock_1eye_4.5d30d78c.png";